module.exports = __webpack_public_path__ + "static/media/elan@3x.cffec546.png";